import app_params from '../../../config/params';

let secureAuthToken = '';
export function setAuthToken(payload: string) {
  // console.log('setAuthToken', payload);
  secureAuthToken = payload;
}
export function removeAuthToken() {
  // console.log('removeAuthToken');
  secureAuthToken = '';
}
export function getAuthToken() : string {
  // console.log('getAuthToken', secureAuthToken);
  return secureAuthToken;
}

function getClientInfo() : Object {
  return {
    version: app_params.CLIENT.VERSION,
  };
}

export class ServerError extends Error {
  response: Object;

  constructor(response: Object, ...params: any): Error {
    super(...params);

    Error.captureStackTrace(this, ServerError);

    this.name = 'ServerError';
    this.response = {};

    return this;
  }
}

export function parseError(error: string): string {
  return error || 'Something went wrong';
}


export function request(path: string, options: Object = {}): Promise<*> {
  const config = {
    method: 'POST',
    ...options,
  };
  const errors = [];

  const endpoint = app_params.GAE_ENDPOINT.BASE_URL;
  const url = endpoint + path;

  if (!url) {
    errors.push('url');
  }

  if (!config.payload && (config.method !== 'GET' && config.method !== 'DELETE')) {
    errors.push('payload');
  }

  if (errors.length) {
    throw new Error(`Error! You must pass \`${errors.join('`, `')}\``);
  }


  const headers = {
    Accept: 'application/json',
    'Content-Type': 'text/plain',
    ...config.headers,
  };

  const params: Object = {
    headers,
    method: config.method,
  };

  const payloadWithAuthToken = {
    ...config.payload,
    token: getAuthToken(),
    client: getClientInfo(),
  };

  if (params.method !== 'GET') {
    params.body = JSON.stringify(payloadWithAuthToken);
  }

  return fetch(url, params)
    .then(async (response) => {
      if (response.status > 299) {
        // console.assert(true, 'not expecting status > 299');
        const error: ServerError = new ServerError(response.statusText);
        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
          error.response = {
            status: response.status,
            data: await response.json(),
          };
        }
        else {
          error.response = {
            status: response.status,
            data: await response.text(),
          };
        }
        throw error;
      }
      else {
        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes('application/json')) {
          return response.json();
        }
        return response.text();
      }
    })
    .catch(async (error) => {
      // const error: ServerError = new ServerError('network error');
      throw error;
    });
}



// WEBPACK FOOTER //
// ./scripts/modules/client.js